export * from './time';
export * from './messages';
export * from './unit-tests';
export * from './titles';
export * from './notification-template';
export * from './company.constants';
export * from './privileges.constants';
import * as serviceConstantsObject from './service.constants';

export let serviceConstants = serviceConstantsObject;

export const systemSpecificTags: any[] = [
  'MOTOR',
  'PartsTech',
  'Nexpart',
  'SpeedDial',
  'Mitchell1',
  'TireHub',
  'TireConnect',
  'RepairLink',
  'Core',
  'Returned',
  'Store',
  'Return',
  'Available',
  'Not Available',
  'Refunded',
];

export const config = {
  toasterConfig: {
    timeOut: 5000,
    extendedTimeOut: 3000,
    positionClass: 'toast-bottom-right',
    enableHtml: true,
  },
  toasterCenterConfig: {
    timeOut: 5000,
    extendedTimeOut: 3000,
    positionClass: 'toast-bottom-center',
    enableHtml: true,
  },
  pageSize: 15,
  shortPageSize: 6,
  pageTenSize: 10,
  pageTwentySize: 20,
  order: -1,
  apppointmentPageSize: 10,
  notificaitonsPageSize: 10,
  activitylogPageSize:0,
  inspectionPageSize: 5,
  chatPageSize: 50,
  searchDelay: 600,
  fileSize: 5000000,
  localServerUrl: 'http://localhost:3000/api/v1',
  tags: {
    customer: 'customer',
    estimates: 'estimate',
    workflowStatus: 'workflow_status',
    service: 'service_tag',
    part: 'part',
    tire: 'brand',
    labor: 'Labor',
    inspection: 'inspection_item_cat',
    other: 'other',
    companyName: 'company_name',
    priority: 'priority',
    supplier: 'supplier',
    fees: 'fees',
    discount: 'discount',
    cannedService: 'service_cat',
  },
  feature: {
    tenantFeature: 'tenantFeature',
  },
  category: {
    service: 'service_cat',
    inspection: 'inspection',
    labor: 'labor',
    part: 'part',
    tire: 'tire',
    tireStorageTemplate: 'tireStorageTemplate',
    fee: 'hazmatFee',
    bundle: 'bundle',
    vehicleColor: 'vehicle_color',
    vehicle: 'vehicle',
    driveType: 'drive_type',
    vehicleTransmission: 'vehicle_transmission',
    priority: 'priority',
    tenant: 'tenant',
    supplier: 'supplier',
    discount: 'discount',
    inpectionReportPromotion: 'inpection_report_promotion'
  },
  defaultCategory: {
    Unassigned: 'Unassigned',
  },
  estimate: {
    defaultOrderStatus: 'estimate',
    authorization: [
      { name: 'NOT APPROVED', authorized: false, color: '#dda157' },
      { name: 'APPROVED', authorized: true, color: '#5c9f52' },
    ],
    archive: [
      { name: 'ARCHIVED', value: true, color: '#dda157' },
      { name: 'UNARCHIVE', value: false, color: '#5c9f52' },
    ],
    orderStatus: [
      { name: 'ESTIMATE', value: 'estimate', send: 'Send Estimate' },
      { name: 'INVOICE', value: 'invoice', send: 'Send Invoice' },
    ],
    defaultServiceTotal: {
      discount: {
        value: 0,
        type: 'percentage',
        name: 'Percent',
      },
      tax: 0,
      parts: 0,
      labor: 0,
      other: 0,
      sub: 0,
      total: 0,
      afterDiscount: 0,
      afterTax: 0,
      grand: 0,
    },
    estimateTotal: {},
    discountType: [
      { name: 'Percent', type: 'percentage', value: 0 },
      { name: 'Fixed', type: 'value', value: 0 },
    ],
  },
  apiSettings: {
    motor: 'MOTOR_LIVE',
  },
  motor: {
    itemsPerPage: '30',
    withRel: 'EWT',
    scheme: 'Shared',
    byTermUrl: '/v1/Information/Vehicles/Search/ByTerm',
    byVinUrl: '/v1/Information/Vehicles/Search/ByVIN',
  },
  reminder: {
    keys: [
      {
        title: 'Hour',
        value: 'h',
      },
      {
        title: 'Day',
        value: 'd',
      },
      {
        title: 'Week',
        value: 'w',
      },
    ],
    timeKeys: [
      {
        title: 'Day',
        value: 'days',
      },
      {
        title: 'Week',
        value: 'weeks',
      },
      {
        title: 'Month',
        value: 'months',
      },
    ],
    frequencys: [
      { title: '1', value: 1 },
      { title: '2', value: 2 },
      { title: '3', value: 3 },
      { title: '4', value: 4 },
      { title: '5', value: 5 },
      { title: '6', value: 6 },
      { title: '7', value: 7 },
      { title: '8', value: 8 },
      { title: '9', value: 9 },
      { title: '10', value: 10 },
      { title: '11', value: 11 },
      { title: '12', value: 12 },
    ],
  },
  defaultTitle: 'Untitled',
  defaultTitleFR: 'Sans titre',
  noCustomerTitle: 'No Customer Assigned',
  noCustomerTitleFR: 'Aucun client attribué',
  noVehicleTitle: 'No Vehicle Assigned',
  noVehicleTitleFR: 'Pas de véhicule attribué',
  noEmail: 'No Email',
  noPhone: 'No Phone',
  noLicense: 'No license plate',
  noVIN: 'No VIN',
  defaultColor: '#00C19F',
  defaultPrimary: '#00C19F',
  defaultAppreciationNote: 'Please take out a few seconds to give us your feedback!',
  defaultAppreciationDialogNote: `Please take a moment to review us on google.
  Each review is highly valuable as it helps new customers discover our business.\n\nWe will
  redirect you to Google Reviews shortly`,
  colors: [
    {
      label: 'Green',
      value: '#00C19F',
    },
    {
      label: 'Red',
      value: '#D47877',
    },
    {
      label: 'Orange',
      value: '#DDA157',
    },
    {
      label: 'Blue',
      value: '#4E94C8',
    },
    {
      label: 'Gray',
      value: '#919796',
    },
  ],

  inspectionStateColors: [
    { label: 'Good', value: '#84DDA7' },
    { label: 'Average', value: '#E8D99B' },
    { label: 'Poor', value: '#E3B0B0' },
  ],
  inspectionStateColorsFR: [
    { label: 'bien', value: '#84DDA7' },
    { label: 'Moyen', value: '#E8D99B' },
    { label: 'Mauvais', value: '#E3B0B0' },
  ],
  redirectUrl: {
    feedback: '/customer-feedback/feedback/setting',
    feedbackPreview: '/customer-feedback/feedback/preview/',
    preview: '/customer-review/preview/',
    previewEnhancedInvoice: '/customer-review/preview-invoice/',
    previewEnhanced: '/customer-review/preview-enhanced/',
    inspectionPreview: '/customer-review/inspectionpreview/',
    insepectionPrint: '/customer-review/printInspectionpreview/',
    repairOrderPrint: '/customer-review/repair-order/printOrder/',
    inspectionLinkpreview: '/customer-review/inspectionLinkpreview/',
    printTechSheet: '/customer-review/worksheetTech/print/',
    printMonthlyRevenue: '/customer-review/monthlyRevenue/print/',
    estimate: '/estimate',
    purchaseOrder: '/purchase-order',
    purchaseOnlineOrder: '/purchase-online-order',
    purchaseTireConnectOnlineOrder: '/purchase-online-order/tire-connect',
    parts: 'lists/parts',
    calendar: '/calendar',
    reviewsSummary: '/reviews/summary',
    customerCenter: '/customer/customer-center',
    qboPostingReport: '/qbo-bulk-post',
    privacyAndSecurity: 'https://autoleap.com/privacy-policy/',
    poOrderList: '/inventory/purchase-order-list',
    poOrderListOnline: '/workboard/partstech-list',
    statementList: '/customers/statements',
    transferStock: '/transfer-stock',
  },
  ratings: [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
  ],
  itemOrderedShowList: [
    { name: 'All items', value: 'allItems' },
    { name: 'Show unused items', value: 'unusedItems', icon: 'fa fa-eye' },
  ],
};

export const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const defaultWorkFlows = {
  estimate: 'Estimate',
  invoice: 'Invoice',
  paid: 'Paid',
  archive: 'Archive',
  inProgress: 'In progress',
};

export const purchaseOrderStatuses = [
  { value: 'draft', label: 'Draft', statusActive: false },
  { value: 'ordered', label: 'Ordered', statusActive: false },
  { value: 'received', label: 'Delivered', statusActive: false },
  { value: 'cancelled', label: 'Canceled', statusActive: false },
];

export const purchaseOrderItemTypes = [
  { value: 'inventory', label: 'Inventory', statusActive: false },
  { value: 'nonInventory', label: 'Non Inventory', statusActive: false },
];

export const vehiclePickUpContent = 'Also you can pick-up your car at pick up scheduled [pickup_date] and [pickup_time]';

export const vehicleTransmissions = [
  { value: 'automatic', label: 'Automatic' },
  { value: 'manual', label: 'Manual' },
];

export const mileageUnits = [
  { value: 'mi', label: 'Miles' },
  { value: 'km', label: 'KM' },
];

export const mileageUnitsMap = {
  mi: 'Miles',
  km: 'KM',
};

export const pricing = {
  labor: 'labor',
  part: 'part',
};

export const importEntities = {
  customer: 'customer',
  vehicle: 'vehicle',
  part: 'part',
  item: 'item',
  inspection: 'inspection',
  labor: 'labor',
  service: 'service',
  template: 'template',
  cannedInspection: 'canned_inspection',
  payment: 'payment',
  appointment: 'appointment',
  review: 'review',
  order: 'order',
  user: 'user',
  inventory: 'inventory',
  contact: 'contact',
  orderDetail: 'order_detail',
  orderLineItem: 'order_line_item',
  paymentDetail: 'payment_detail',
  tireStorageDetail: 'tire_storage_detail',
  tireStorageItemDetail: 'tire_storage_item_detail',
  users: 'users',
};

export const noteType = {
  serviceNotes: 'servieNote',
  shopNotes: 'shopNotes',
  vehicleNote: 'vehicleNote',
  customerNotes: 'customerNotes',
};

export const filterTitle = {
  authorization: {
    all: 'Authorization',
    multipleAuth: 'Multiple Authorizations',
    approved: 'Approved',
    notApproved: 'Not Approved',
    partiallyApproved: 'Partially Approved',
  },
  serviceWriter: {
    all: 'Service advisor',
    multiple: 'Multiple service advisor',
    unassigned: 'Unassigned'
  },
  aging: {
    all: 'Aging',
    flagged: 'Above limit',
    notflagged: 'Within limit',
  },
  quotation: {
    all: 'All',
    send: 'Sent',
    notSend: 'Not sent',
  },
  payment: {
    all: 'All',
    unpaid: 'Unpaid',
    partiallyPaid: 'Partially paid',
    paid: 'Fully paid',
  },
  paymentCashNonCash: {
    all: 'All',
    cash: 'Cash',
    nonCash: 'Non Cash',
  },
  deliveryStatus: {
    multiple: 'Multiple status',
  },
  tags: {
    all: 'RO tag',
    multiple: 'Multiple tags',
  },
  priorities: {
    all: 'Prioritization',
    multiple: 'Multiple priorities',
  },
  itemType: {
    all: 'Item type',
    multiple: 'Item type',
  },
  customerTags: {
    all: 'Customer tag',
    multiple: 'Multiple tags',
  },
  techs: {
    all: 'Technicians',
    multiple: 'Multiple techs',
  },
  workflow: 'Workflow',
  archives: {
    all: 'All',
    archived: 'Archived',
    unArchived: 'Active',
  },
  orderStatus: {
    all: 'All',
    invoice: 'Invoice',
    estimate: 'Estimate',
  },
  payableStatus: {
    all: 'All',
    due: 'Due',
    notDue: 'Not due',
  },
  qbo: {
    notPosted: 'Not posted',
    outOfSync: 'Out of sync',
    synced: 'Synced',
    all: 'All',
  },
  supplier: {
    all: 'All',
    multiple: 'Multiple supplier',
  },
  campaign: {
    all: 'All',
    multiple: 'Campaign Name',
  },
  campaignStatus: {
    all: 'All',
    multiple: 'Status Name',
  },
  followup: {
    all: 'All',
    multiple: 'Follow-up Name',
  },
  date: 'This week',
};

export const paymentTypes = [
  {
    value: 'cash',
    label: 'Cash',
    icon: 'fal fa-money-bill',
    active: true,
    disabled: false,
  },
  {
    value: 'card',
    label: 'Card',
    icon: 'fal fa-credit-card-front',
    active: false,
    disabled: false,
  },
  {
    value: 'cheque',
    label: 'Cheque / Bank',
    icon: 'fal fa-money-check-alt',
    active: false,
    disabled: false,
  },
];
export const billPaymentTypes = [
  {
    value: 'bank',
    label: 'Bank',
    icon: 'fal fa-money-bill',
    active: false,
  },
  {
    value: 'creditCard',
    label: 'Credit card',
    icon: 'fal fa-credit-card-front',
    active: false,
  },
  // {
  //   value: 'otherCurrentAsset',
  //   label: 'Other Current Asset',
  //   icon: 'fal fa-money-check-alt',
  //   active: true,
  // },
];
export const calendarDayNumberMap = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const inspectionItemColorIndex = {
  0: 'good',
  1: 'normal',
  2: 'bad',
};

export const findingItemIcon = {
  0: 'fal fa-check-circle',
  1: 'fal fa-info-circle',
  2: 'fal fa-times-circle',

};

export const findingItemColorLabel = {
  1: 'Needs Monitoring',
  2: 'Needs Immediate Attention',
};
export const findingItemColorLabelFR = {
  1: 'BESOIN DE SUIVI',
  2: 'BESOIN D\'UNE ATTENTION IMMÉDIATE',
};

export const workStateTitle = {
  pause: 'Paused',
  inprogress: 'In progress',
  completed: 'Completed',
  new: 'Not started',
  noTech: 'Not Assigned',
};
export const workStateTitleFR = {
  pause: 'En pause',
  inprogress: 'En cours',
  completed: 'Terminé',
  new: 'Non commencé',
  noTech: 'Non assigné',
};

export const workStateIcon = {
  pause: '../../../../../../../assets/img/tech-work-paused.svg',
  inprogress: '../../../../../../../assets/img/tech-work-inprogress.svg',
  completed: '../../../../../../../assets/img/tech-work-completed.svg',
  new: '../../../../../../../assets/img/tech-work-notstarted.svg',
  noTech: '../../../../../assets/img/no_tech_assigned.svg',
};

export const workStateIconSolid = {
  pause: '../../../../../../../assets/img/tech-work-paused-s.svg',
  inprogress: '../../../../../../../assets/img/tech-work-inprogress-s.svg',
  completed: '../../../../../../../assets/img/tech-work-completed-s.svg',
  new: '../../../../../../../assets/img/tech-work-notstarted-s.svg',
  noTech: '../../../../../../../assets/img/no_tech_assigned.svg',
};

export const motorLinkedOptions = [
  { label: 'Update vehicle', value: 'update' },
  { label: 'Disconnect', value: 'disconnect' },
];

export const jobStatusMap = {
  new: 'Start',
  inprogress: 'Pause',
  pause: 'Resume',
  completed: 'Restart',
};
export const jobStatusMapFR = {
  new: 'Démarrer',
  inprogress: 'Pause',
  pause: 'Reprendre',
  completed: 'Redémarrer',
};

export const jobStatusVisitorMap = {
  new: 'Not Started',
  inprogress: 'In Progress',
  pause: 'Pause',
  completed: 'Completed',
};
export const jobStatusVisitorMapFR = {
  new: 'Non commencé',
  inprogress: 'En cours',
  pause: 'Pause',
  completed: 'Terminé',
};

export const unAssignedPartsTechPartsMessage = {
  submitted: {
    noAssociated: {
      // title: 'Continue with unassigned PartsTech parts',
      title: 'Continue with unassigned Parts Ordering parts',
      message: 'There is a submitted Parts Order, but not all parts are associated to Services on this Estimate. Are you sure you want to continue?',
    },
  },
  unSubmitted: {
    associated: {
      // title: 'Continue with unsubmitted PartsTech cart',
      title: 'Continue with unsubmitted Parts Ordering cart',
      message: 'This Estimate has parts from a Parts Order that is not submitted. Are you sure you want to continue?',
    },
    noAssociated: {
      // title: 'Continue with unsubmitted PartsTech cart',
      title: 'Continue with unsubmitted Parts Ordering cart',
      message: 'There is an unsubmitted Parts Order on this Estimate. Are you sure you want to continue?',
    },
  },
};

export const paymentTypeTitle = {
  cash: 'Cash',
  card: 'Card',
  cardManual: 'Card Manual',
  cardOnline: 'Card Online',
  cheque: 'Check',
  cardSwipe: 'Card Swipe',
  creditPayment: 'Credit',
  thirdParty: '3rd Party',
  writeOff: 'Write-off'
};

export const paymentStatsHeaderList = [
  {
    title: 'Cash',
    icon: 'fal fa-money-bill',
    total: 0,
    percent: 0,
    value: 'cash',
    collected: 0,
    refund: 0,
    isVisible: true,
  },
  {
    title: 'Cheque',
    icon: 'fal fa-money-check-alt',
    total: 0,
    percent: 0,
    value: 'cheque',
    collected: 0,
    refund: 0,
    isVisible: true,
  },
  {
    title: 'Card',
    icon: 'fal fa-credit-card-front',
    total: 0,
    percent: 0,
    value: 'card',
    collected: 0,
    refund: 0,
    isVisible: true,
  },
  {
    title: 'Credit',
    icon: 'fal fa-credit-card',
    total: 0,
    percent: 0,
    value: 'creditPayment',
    collected: 0,
    refund: 0,
    isVisible: false,
  },
  {
    title: '3rd Party',
    icon: 'fal fa-store',
    total: 0,
    percent: 0,
    value: 'thirdParty',
    collected: 0,
    refund: 0,
    isVisible: false,
  },
  {
    title: 'Write-offs',
    icon: 'fal fa-money-check-alt',
    total: 0,
    percent: 0,
    value: 'writeOff',
    collected: 0,
    refund: 0,
    isVisible: false,
  },
];

export const units = {
  parts: 'qty',
  labor: 'hrs',
  fluids: {
    pint: 'pt',
    gallon: 'gal',
    quart: 'qt',
    liter: 'ltr',
    millilitre: 'ml',
    ounce: 'oz',
  },
};

export const twelveMoths = [
  { label: '15 Days | 0.5 Months', value: 15 },
  { label: '30 Days | 1 Months', value: 30 },
  { label: '45 Days | 1.5 Months', value: 45 },
  { label: '60 Days | 2 Months', value: 60 },
  { label: '75 Days | 2.5 Months', value: 75 },
  { label: '90 Days | 3 Months', value: 90 },
  { label: '120 Days | 4 Months', value: 120 },
  { label: '135 Days | 4.5 Months', value: 135 },
  { label: '150 Days | 5 Months', value: 150 },
  { label: '165 Days | 5.5 Months', value: 165 },
  { label: '180 Days | 6 Months', value: 180 },
];

export const serviceStatusEnum = ['new', 'inprogress', 'pause', 'completed'];

export const defaultEstimate = Object.freeze({
  title: '',
  authorized: false,
  start: new Date(),
  end: null,
  orderStatus: config.estimate.defaultOrderStatus,
  notes: '',
  customerNotes: '',
  shopNotes: '',
  techs: [],
  customer: {},
  vehicle: {},
  tags: [],
  appointments: [],
  services: [],
  inspections: [],
  isPickupScheduled: false,
  pickupDate: null,
});

export const serviceAuthConsts = {
  pending: 'pending',
  approved: 'approved',
  deferred: 'deferred',
  declined: 'declined',
  archived: 'archived',
  deferredLocked: 'deferredLocked',
};

export const serviceAuthIcons = {
  pending: 'history',
  approved: 'check-circle',
  deferred: 'history',
  declined: 'times-circle',
  archived: 'times-circle',
  deferredLocked: 'history',
};

export const inspectionCategoryColorIndex = {
  0: 'red',
  1: 'yellow',
  2: 'green',
};

export const quickbooksHelpLink = 'https://quickbooks.intuit.com/global/faq/';
export const quickbooksProductHelpLink = 'https://quickbooks.intuit.com/learn-support/en-us/service-items/add-inventory-products-in-quickbooks-online/01/187793';
export const quickbooksLocationHelpLink = 'https://quickbooks.intuit.com/learn-support/en-za/help-article/track-location/set-use-location-tracking/L2raFkEBC_ZA_en_ZA?uid=m5v6owom';
export const carfaxHelpLink = 'https://www.carfax.com/';
export const carfaxTerms = 'https://www.carfax.com/company/terms-of-use';

export const payrixStatus = {
  Approved: 1,
  Captured: 2,
  Refund: 4,
};

export const primaryContactConstant = {
  email: 'email',
  mobile: 'mobile',
  both: 'both',
  none: 'none',
};

export const qualityMap = {
  0: '30',
  1: '20',
  2: '10',
};

export const orderStatusLabel = {
  draft: 'Draft',
  ordered: 'Ordered',
  received: 'Delivered',
  cancelled: 'Canceled',
};
export const tirePositionOptions: any[] = [
  { name: 'Front left (FL)', value: 'FL', order: 0, class: 'left' },
  { name: 'Front right (FR)', value: 'FR', order: 1, class: 'right' },
  { name: 'Rear left (RL)', value: 'RL', order: 2, class: 'bottom-left' },
  { name: 'Rear right (RR)', value: 'RR', order: 3, class: 'bottom-right' },
  { name: 'Spare 1', value: 'S1', order: 4, class: '' },
  { name: 'Spare 2', value: 'S2', order: 5,class: '' },
];

export const seasonalityOptions: any[] = [
  { name: 'Summers', value: 'summer' },
  { name: 'Winters', value: 'winter' },
  { name: 'All season', value: 'all' },
];

export enum filterType {
  singleSelect,
  multipleSelect,
}

export const finalizeRevenueFilterReportData: any[] = [
  { name: 'Fully paid', isHeader: false, nameSort: 'finalized', key: 'fullyPaid', value: 'finalized' },
  { name: 'Send to AR', isHeader: false, nameSort: 'finalized', key: 'accountsReceivable', value: 'finalized' },
];

export const finalizeRevenueFilterData: any[] = [
  { name: 'Not finalized', isHeader: false, nameSort: 'notFinalized', key: 'notFinalized', value: 'notFinalized', isMakeBold: true },
  { name: 'Finalized', isHeader: true, nameSort: 'finalized', key: 'finalized', value: 'finalized' },
  { name: 'Fully paid', isHeader: false, nameSort: 'finalized', key: 'fullyPaid', value: 'finalized' },
  { name: 'Send to AR', isHeader: false, nameSort: 'finalized', key: 'accountsReceivable', value: 'finalized' },
];

export const finalizeROTypeFilterData: any[] = [
  { name: 'Non 3rd Party', isHeader: false, nameSort: 'nonThirdParty', key: 'nonThirdParty', value: 'nonThirdParty' },
];

export const tireTypeSuggestions: any[] = [
  { tireTypeId: '0', name: 'Not Defined', isCommercial: false },
  { tireTypeId: '1', name: 'Passenger', isCommercial: false },
  { tireTypeId: '2', name: 'Light Truck/SUV', isCommercial: false },
  { tireTypeId: '3', name: 'Medium/Heavy Trucks', isCommercial: false },
  { tireTypeId: '4', name: 'Special Trailer', isCommercial: true },
  { tireTypeId: '5', name: 'Agriculture', isCommercial: true },
  { tireTypeId: '6', name: 'Mining', isCommercial: true },
  { tireTypeId: '7', name: 'ATV/UTV', isCommercial: true },
];

export const finalizeRevenueFilterOption: any = {
  iconClass: 'fa-money-check-alt',
  nameField: 'name',
  valueField: 'key',
  //countField: 'count',
  selectAllText: 'Finalize type',
  multipleSelectText: 'Multiple selected',
  styleCss: {
    'font-weight': '600',
    padding: '0 3px',
  },
  filterOverlayStyle: {
    width: '230px',
  },
  filterOverlayClass: '',
  scrollHeight: '300px',
};
export const RoTypeFilterOption: any = {
  iconClass: 'fa-money-check-alt',
  nameField: 'name',
  valueField: 'key',
  //countField: 'count',
  selectAllText: '3rd Party',
  multipleSelectText: 'Multiple selected',
  styleCss: {
    'font-weight': '600',
    padding: '0 3px',
  },
  filterOverlayStyle: {
    width: '315px',
  },
  filterOverlayClass: '',
  scrollHeight: '300px',
};
